//TODO replace with our react shit

import { Button, Heading, View, defaultTheme, useAuthenticator } from "@aws-amplify/ui-react";

import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";

export const components = {
  Header() {
    const { tokens } = defaultTheme;

    return (
      <View textAlign="center" padding={tokens.space.large} height="150px">
        {/* <Image alt="Amplify logo" src="https://docs.amplify.aws/assets/logo-dark.svg" /> */}
      </View>
    );
  },

  Footer() {
    const omnisciaLogo = `${window.location.origin}/omnisciaLogo.png`;
    const theme = useTheme();

    return (
      <Box
        sx={{
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingBottom: 0,
          maxHeight: 36,
          minHeight: 36,
          display: "flex",
          flexDirection: "row",
          userSelect: "none",
          webkitUserSelect: "none",
          position: "relative",
          backgroundColor: "#fff",
          borderRadius: "0px 0px 16px 16px",
          borderTop: "solid 1px #C4C4C4",
          boxShadow: `0px 3px 1px -2px #33333310, 0px 3px 4px 0px #33333310, 0px 1px 8px 0px #33333310`,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              background: `url(${omnisciaLogo})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              width: "16px",
              height: "16px",
              margin: "4px",
            }}
          />
          <Typography
            variant="overline"
            sx={{
              marginTop: "2px",
            }}
          >
            {"Powered By: Omniscia Health"}
          </Typography>
        </Box>
      </Box>
    );
  },

  SignIn: {
    Header() {
      const theme = useTheme();
      return (
        <Box
          sx={{
            padding: `8px 0px 0px 28px`,
            marginBottom: "-16px",
            borderBottom: "solid 1px #C4C4C4",
            userSelect: "none",
          }}
        >
          <Typography variant="overline">Welcome!</Typography>
          <Typography
            variant="h5"
            sx={{ marginTop: `-${theme.spacing(1.5)}`, marginBottom: `${theme.spacing(1)}` }}
          >
            Sign in to your account
          </Typography>
        </Box>
      );
    },
    Footer() {
      const { toResetPassword } = useAuthenticator();
      const theme = useTheme();
      return (
        <View
          textAlign="center"
          marginTop={`-${theme.spacing(2)}`}
          paddingBottom={theme.spacing(2)}
        >
          <Button fontWeight="normal" onClick={toResetPassword} size="small" variation="link">
            Reset Password
          </Button>
        </View>
      );
    },
  },

  SignUp: {
    Header() {
      const { tokens } = defaultTheme;

      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Create a new account
        </Heading>
      );
    },
    Footer() {
      const { toSignIn } = useAuthenticator();
      const theme = useTheme();
      return (
        <View
          textAlign="center"
          marginTop={`-${theme.spacing(2)}`}
          paddingBottom={theme.spacing(2)}
        >
          <Button fontWeight="normal" onClick={toSignIn} size="small" variation="link">
            Back to Sign In
          </Button>
        </View>
      );
    },
  },
  ConfirmSignUp: {
    Header() {
      const { tokens } = defaultTheme;
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Enter Information:
        </Heading>
      );
    },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  SetupTOTP: {
    Header() {
      const { tokens } = defaultTheme;
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Enter Information:
        </Heading>
      );
    },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  ConfirmSignIn: {
    Header() {
      const { tokens } = defaultTheme;
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Enter Information:
        </Heading>
      );
    },
    // Footer() {
    //   return <Text>Footer Information</Text>;
    // },
  },
  ResetPassword: {
    Header() {
      const theme = useTheme();
      return (
        <Box
          sx={{
            marginLeft: "-32px",
            marginRight: "-32px",
            marginTop: "-24px",
            paddingLeft: "32px",
            paddingRight: "32px",
            marginBottom: 0,
            borderBottom: "solid 1px #C4C4C4",
            userSelect: "none",
          }}
        >
          <Typography variant="overline">Account Support</Typography>
          <Typography
            variant="h5"
            sx={{ marginTop: `-${theme.spacing(1.5)}`, marginBottom: `${theme.spacing(1)}` }}
          >
            Reset Your Password
          </Typography>
        </Box>
      );
    },
    Footer() {
      return (
        <Typography textAlign="center" variant="body">
          We'll send a confirmation code to your email within the next couple minutes
        </Typography>
      );
    },
  },
  ConfirmResetPassword: {
    Header() {
      const theme = useTheme();
      return (
        <Box
          sx={{
            marginLeft: "-32px",
            marginRight: "-32px",
            marginTop: "-24px",
            paddingLeft: "32px",
            paddingRight: "32px",
            marginBottom: 0,
            borderBottom: "solid 1px #C4C4C4",
            userSelect: "none",
          }}
        >
          <Typography variant="overline">Account Support</Typography>
          <Typography
            variant="h5"
            sx={{ marginTop: `-${theme.spacing(1.5)}`, marginBottom: `${theme.spacing(1)}` }}
          >
            Reset Your Password
          </Typography>
        </Box>
      );
    },
    Footer() {
      const theme = useTheme();
      return (
        <>
          <Typography variant="body" textAlign="center">
            Your confirmation code should be in your email inbox.
          </Typography>
          <Typography
            variant="body"
            textAlign="center"
            sx={{ marginTop: `-${theme.spacing(1.5)}` }}
          >
            If it's not there in the next couple of minutes click the Resend Code button
          </Typography>
        </>
      );
    },
  },
};

export const formFields = {
  signIn: {
    username: {
      placeholder: "Enter Your User Name",
      isRequired: true,
      label: "User Name:",
    },
  },
  signUp: {
    password: {
      label: "Password:",
      placeholder: "Enter your Password:",
      isRequired: false,
      order: 2,
    },
    confirm_password: {
      label: "Confirm Password:",
      order: 1,
    },
  },
  forceNewPassword: {
    password: {
      placeholder: "Enter your Password:",
    },
  },
  resetPassword: {
    username: {
      placeholder: "Enter your Username:",
    },
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: "Enter your Confirmation Code",
      label: "Confirmation Code",
      isRequired: false,
    },
    password: {
      placeholder: "Enter your New Password",
    },
    confirm_password: {
      placeholder: "Confirm your Password",
    },
  },
  setupTOTP: {
    QR: {
      totpIssuer: "test issuer",
      totpUsername: "amplify_qr_test_user",
    },
    confirmation_code: {
      label: "Confirmation Code",
      placeholder: "Enter your Confirmation Code:",
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      label: "Confirmation Code",
      placeholder: "Enter your Confirmation Code:",
      isRequired: false,
    },
  },
};

export const getFormFields = userName => {
  let tmp = {
    signIn: {
      username: userName
        ? {
            defaultValue: userName,
            placeholder: "Enter Your User Name",
            isRequired: true,
            label: "User Name:",
          }
        : {
            placeholder: "Enter Your User Name",
            isRequired: true,
            label: "User Name:",
          },
    },
    signUp: {
      password: {
        label: "Password:",
        placeholder: "Enter your Password:",
        isRequired: false,
        order: 2,
      },
      confirm_password: {
        label: "Confirm Password:",
        order: 1,
      },
    },
    forceNewPassword: {
      password: {
        placeholder: "Enter your Password:",
      },
    },
    resetPassword: {
      username: {
        defaultValue: userName,
        placeholder: "Enter your Username:",
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: "Enter your Confirmation Code",
        label: "Confirmation Code",
        isRequired: true,
      },
      confirm_password: {
        placeholder: "Confirm your New Password",
        isRequired: true,
      },
    },
    setupTOTP: {
      QR: {
        totpIssuer: "test issuer",
        totpUsername: "amplify_qr_test_user",
      },
      confirmation_code: {
        label: "Confirmation Code",
        placeholder: "Enter your Confirmation Code:",
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: "Confirmation Code",
        placeholder: "Enter your Confirmation Code:",
        isRequired: false,
      },
    },
  };
  return tmp;
};

const theExports = {
  components,
  formFields,
};
export default theExports;
